<template>
  <v-container>
    <v-container style="height: calc(100vh - 245px); overflow-y: auto">
      <v-list class="locales">
        <v-list-item
          v-for="(locale, i) in locales"
          :key="i"
          @click="setLocale(locale.code)"
        >
          <v-list-item-icon>
            <v-img
              :src="locale.icon"
              min-height="24px"
              min-width="33px"
            />
          </v-list-item-icon>
          <v-list-item-title>
            {{ locale.label }}
          </v-list-item-title>
          <v-list-item-icon v-if="selectedLocale === locale.code">
            <v-icon>mdi-check</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-container>
    <v-container
      class="px-3 pt-3 pb-8"
      style="position: fixed; bottom: 0; left: 0; background: #fff"
    >
      <v-card>
        <v-container>
          <h4>{{ $t("localeSelection.interpreterService") }}</h4>
          <p v-html="interpreterServiceHtml()" />
          <h4>{{ $t("localeSelection.translatedDocument") }}</h4>
          <a @click="openTranslatedDocuments()">
            {{ $t("localeSelection.translatedDocumentLink") }}
          </a>
          <v-container />
        </v-container>
      </v-card>
    </v-container>
  </v-container>
</template>
<script>
import { remoteConfig } from "@/mixins/remoteConfig";
import locales from "@/settings/supported-locales";

const localeSelector = {
  name: "LocaleSelector",
  data: () => ({
    locales: locales
  }),
  computed: {
    selectedLocale() {
      return this.$i18n.locale;
    }
  },
  methods: {
    interpreterServiceHtml() {
      return this.$t("localeSelection.interpreterServiceDescription");
    },
    setLocale(code) {
      this.$i18n.locale = code;
      this.setCookie("locale", code, 365);
      //eslint-disable-next-line
      NativeJS.setLocale(code);
    },
    openTranslatedDocuments() {
      const link = remoteConfig("translatedDocumentsLink");
      //eslint-disable-next-line
      NativeJS.externalLink(link);
    }
  }
};

export default localeSelector;
</script>
<style lang="scss">
.locales {
  .v-icon.theme--light.mdi-check {
    color: #407ec9;
  }
  .v-list-item {
    font-size: 18px;
    padding: 0;
    margin: 0 16px;
    border-bottom: 1px solid #407ec9;
  }
  .v-list-item__icon {
    min-width: 33px;
  }
}
</style>
